@if (data.action == 'add') {
  <mat-horizontal-stepper linear="true" #stepper>
    <mat-step [stepControl]="formStepeOne">
      <form [formGroup]="formStepeOne">
        <ng-template class="font" matStepLabel>Selección de equipo</ng-template>
        <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 10px;
        "
          >
          <div
          style="
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
          "
            >
            <div style="width: 50%">
              <data-table
                title=""
                [columns]="columnasEquipos"
                [configuration]="configurationEquipos"
                [reloadTable]="recargarTablaEquipos"
                (clickRow)="clickFilaEquipos($event)"
                [params]="[{ id: 'state', value: 1 }]"
                [url]="urlTablaEquipos"
                >
              </data-table>
            </div>
            @if (imageSrc != '') {
              <div style="width: 50%; text-align: center">
                <h2>{{ equipo.code}}</h2>
                <img
                  class="mat-elevation-z8"
                  src="{{ imageSrc }}"
                  [ngStyle]="sizePicture"
                  />
                <h2 style="margin-top: 5px">código: {{ equipo.code }}</h2>
              </div>
            }
            <div style="display: none">
              <mat-form-field>
                <input
                  autocomplete="off"
                  type="text"
                  formControlName="equipmentId"
                  matInput
                  required
                  />
              </mat-form-field>
            </div>
          </div>
          @if (imageSrc != '') {
            <button
              matStepperNext
              style="width: 70%; margin-top: 15px"
              color="primary"
              class="button-save mat-elevation-z5"
              mat-raised-button
              >
              Aceptar
            </button>
          }
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="formFO">
      <ng-template class="font" matStepLabel>Orden De Combustible</ng-template>
      <ng-container *ngTemplateOutlet="formFuelOrder"></ng-container>
    </mat-step>
  </mat-horizontal-stepper>
}

@if (data.action == 'edit') {
  <mat-tab-group style="padding: 50px">
    <mat-tab label="Orden de combustible">
      <ng-container *ngTemplateOutlet="formFuelOrder"></ng-container>
    </mat-tab>
  </mat-tab-group>
}

@if (data.action == 'solicitud') {
  <mat-horizontal-stepper
    linear="true"
    #stepper
    >
    <mat-step [stepControl]="formFO">
      <ng-template matStepLabel>{{ actividad.label }}</ng-template>
      <ng-container *ngTemplateOutlet="formFuelOrder"></ng-container>
    </mat-step>
  </mat-horizontal-stepper>
}

<ng-template #formFuelOrder>
  <form
    [formGroup]="formFO"
    (ngSubmit)="formFO.valid ? saveFO($event, formFO.value) : errorMessage()"
    style="overflow: auto"
    >
    <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
      <div style="display: flex; width: 100%; margin-top: 10px">
        <div [style.flex]="data.action == 'edit'? 10 : 12">
          <div class="first-row">
            <div class="row-item">
              <mat-form-field>
                <mat-label>Código equipo</mat-label>
                <input
                  [value]="equipo.code"
                  matInput
                  readonly
                  placeholder="Código equipo"
                  />
              </mat-form-field>
            </div>
            <div class="row-item">
              <!-- Manager  -->
              <combos
                [control]="formFO.get('requests')"
                [configuration]="combosConfigManager"
                [reloadCombo]="reloadComboManager"
                [required]="true"
                [filter]="true"
                [disabled]="data.action == 'edit'"
                >
              </combos>
            </div>
            <div class="row-item">
              <mat-form-field [appOpenDatepickerOnClick]="picker">
                <mat-label>Fecha</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  autocomplete="off"
                  matInput
                  required
                  formControlName="date"
                  (ngModelChange)="checkDateRange($event)"
                  />
                <mat-datepicker-toggle matIconSuffix [for]="picker">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #picker
                  [touchUi]="movil ? true : false"
                ></mat-datepicker>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="default-row">
            <div class="row-item">
              <combos
                [control]="formFO.get('providerId')"
                [configuration]="combosProvider"
                [reloadCombo]="reloadProvider"
                [required]="true"
                [filter]="true"
                [additionalData]="provider"
                (changeOptionDataComplete)="ValueIDProvider($event)"
                >
              </combos>
            </div>

            @if (providerOther) {
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Lugar (otro)</mat-label>
                  <input
                    required
                    autocomplete="off"
                    type="text"
                    formControlName="place"
                    matInput
                    #lugar_otro
                    oninput="this.value = this.value.slice(0,100)"
                    placeholder="Lugar (otro)"
                    />
                  <mat-hint>{{ lugar_otro.value.length }}/100</mat-hint>
                  <mat-error>Campo requerido</mat-error>
                </mat-form-field>
              </div>
            }

            <div class="row-item">
              <mat-form-field>
                <mat-label>Tipo de Combustible</mat-label>
                <mat-select formControlName="fuelType" required>
                  @for (item of fuelType; track item) {
                    <mat-option [value]="item">{{
                      item
                    }}</mat-option>
                  }
                </mat-select>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>

            <div class="row-item">
              <combos
                [control]="formFO.get('authorizes')"
                [configuration]="combosConfigauthorize"
                [reloadCombo]="reloadComboauthorize"
                [required]="true"
                [filter]="true"
                >
              </combos>
            </div>
          </div>

          <div class="default-row">
            <div class="row-item">
              <mat-form-field>
                <mat-label>Galones</mat-label>
                <input
                  autocomplete="off"
                  type="number"
                  matInput
                  formControlName="gallons"
                  #galones
                  oninput="this.value = this.value.slice(0,8)"
                  placeholder="Galones"
                  />
                <mat-hint>{{ galones.value.length }}/8</mat-hint>
              </mat-form-field>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Precio Total</mat-label>
                <input
                  autocomplete="off"
                  type="text"
                  appThousandSeparator
                  formControlName="totalPrice"
                  matInput
                  #precio_total
                  oninput="this.value = this.value.slice(0,12)"
                  placeholder="Precio Total"
                  />
                <mat-hint>{{ precio_total.value.length }}/12</mat-hint>
              </mat-form-field>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Descripción</mat-label>
                <input
                  autocomplete="off"
                  type="text"
                  formControlName="description"
                  matInput
                  #descripcion
                  oninput="this.value = this.value.slice(0,150)"
                  placeholder="Descripción"
                  />
                <mat-hint>{{ descripcion.value.length }}/150</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>

        @if (data.action == 'edit') {
          <div style="flex: 0.2">
            <button mat-mini-fab color="warn" type="submit">
              <mat-icon>save</mat-icon>
            </button>
            <button
              mat-mini-fab
              color="accent"
              (click)="deleteFO($event)"
              style="margin-top: 10px"
              >
              <mat-icon>delete</mat-icon>
            </button>
            @if (screen) {
              <button mat-mini-fab color="accent" type="button" (click)='print($event, formFO.value)'
                style='margin-top: 10px;'>
                <mat-icon>print</mat-icon>
              </button>
            }
            <button
              mat-mini-fab
              color="primary"
              (click)="back($event)"
              style="margin-top: 10px"
              >
              <mat-icon>reply</mat-icon>
            </button>
          </div>
        }

      </div>

      @if (data.action != 'edit') {
        <div style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">
          <button name="F" [disabled]="buttonEnd" style="width: 45%; margin-top: 15px;" color="primary" class="button-save mat-elevation-z5 "
          mat-raised-button type="submit" >Finalizar</button>
          <button name="FI" style="width: 45%; margin-top: 15px;" color="warn"  class="button-save mat-elevation-z5 print"
          type="submit"  mat-raised-button>Finalizar e imprimir</button>
        </div>
      }

    </cdk-virtual-scroll-viewport>
  </form>
</ng-template>
